import { Descriptions, Dropdown, Input, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom"; 
import InsideHeader from "../../../components/InsideHeader";
import svg38 from "../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import { fetchStaffNetPays } from "../../../features/dropdown/dropdownSlice"; 

export default function CasualAttendanceDetailsTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { staffNetPays, loading, staffNetPaysCount } = useSelector(
    (state) => state.dropdown
  );
  const { attendanceObj } = useSelector((state) => state.folder);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(fetchStaffNetPays());
    await setFilters([]);
  };

  const [prodd, setProdd] = useState("");
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  
  const handleNdovu = async () => {
    // navigate("/ndovu-pay");
  };

  const handleExport = () => {};

  const handleView = () => {};

  const columns = [
    {
      title: "TypeAdd payroll item details",
      dataIndex: "ppPfno",
      sorter: (a, b) => a.ppPfno.localeCompare(b.ppPfno),
    },
    {
      title: "Latitude",
      dataIndex: "ppFullname",
      sorter: (a, b) => a.ppFullname.localeCompare(b.ppFullname),
    },
    {
      title: "Longitude",
      dataIndex: "itemname",
      sorter: (a, b) => a.itemname.localeCompare(b.itemname),
    },
    
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchStaffNetPaysData(page, size) {
    dispatch(
      fetchStaffNetPays({
        limit: size ?? pageSize,
        start: page ?? pageIndex,
     
      })
    );
  }

  useEffect(() => {
    fetchStaffNetPaysData();
  }, []);

  const items = [
    {
      key: "1",
      label: "Date",
      children: attendanceObj?.fpPyear,
    },
    {
      key: "2",
      label: "Personnel No",
      children: attendanceObj?.fpPmonth,
    },
    {
      key: "3",
      label: "Name",
      children: attendanceObj?.fpPmonth,
    },
    {
      key: "4",
      label: "Clocked In",
      children: attendanceObj?.fpPmonth,
    },
    {
      key: "5",
      label: "Clocked Out",
      children: attendanceObj?.fpPmonth,
    },
    {
      key: "6",
      label: "Hours Worked",
      children: attendanceObj?.fpPmonth,
    },
    {
      key: "7",
      label: "Overtime Hours Worked",
      children: attendanceObj?.fpPmonth,
    },


   
  ];

  return (
    <div className="w-full h-full overflow-y-scroll">
      <InsideHeader
        title="Attendance Details Information"
        subtitle="Manage Attendance Details within your institution"
        back={true}
        title1="Attendance Entries"
        title2="Attendance Details"
      />

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
              column={2}
              colon={false}
              title="Fiscal Period Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Attendance Details  
            </h3>
             
          </div>
        
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.ptId}
                columns={columns}
                dataSource={staffNetPays}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: staffNetPaysCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchStaffNetPaysData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

    
    </div>
  );
}
